module.exports = __webpack_public_path__ + "img/timebox.55543617.png";